/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Content } from '../../models/content';

export interface IlsControllerDuplicateContentToIls$Params {
  ilsId: string;
  phaseId: string;
  sourceContentId: string;
}

export function ilsControllerDuplicateContentToIls(http: HttpClient, rootUrl: string, params: IlsControllerDuplicateContentToIls$Params, context?: HttpContext): Observable<StrictHttpResponse<Content>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerDuplicateContentToIls.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.path('phaseId', params.phaseId, {});
    rb.path('sourceContentId', params.sourceContentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Content>;
    })
  );
}

ilsControllerDuplicateContentToIls.PATH = '/ils/{ilsId}/{phaseId}/{sourceContentId}/duplicate';
